import type { FilterItem } from '../schedule.helpers';
import { ScheduleFilterType } from '../../../../../types/enums';
import type { Class } from '../../../../../types/tournament';
import type { ScheduleTeamFilterOption } from '../../../../../features/schedule/scheduleSelectors';

export function buildScheduleFilterSummary(
  currentFilters: FilterItem[],
  classIdToObject: Record<number, Class>,
  teamFilterOptions: ScheduleTeamFilterOption[],
  t: (key: string, opts?: Record<string, unknown>) => string,
  prefix: string
): string {
  const classIds = currentFilters
    .filter((f) => f.type === ScheduleFilterType.CLASS)
    .map((f) => Number(f.value));
  const teamIds = currentFilters
    .filter((f) => f.type === ScheduleFilterType.TEAM)
    .map((f) => Number(f.value));

  if (classIds.length === 0 && teamIds.length === 0) {
    return t(prefix + 'schedulePrintFilteredAll');
  }

  const classNames = classIds
    .map((id) => classIdToObject[id]?.name)
    .filter(Boolean) as string[];
  const teamNames = teamIds
    .map((id) => teamFilterOptions.find((o) => o.value === id)?.label)
    .filter(Boolean) as string[];

  const parts = [...classNames, ...teamNames];
  return t(prefix + 'schedulePrintFiltered', { filters: parts.join(', ') });
}
